<template>
  <div
    v-if="$isWeb"
    class="cube-icon-container"
    :class="[{ 'font-size-100': fontSize100 }, name]"
  >
    <!-- #ifdef H5 -->
    <symbol-icon
      v-if="type === 'symbol'"
      :name="name"
      :color="color"
      :width="_width"
      :height="_height"
      :class-name="className"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <!-- #endif -->
    <image-icon
      v-if="type === 'svg' || type === 'png'"
      :name="name"
      :type="type"
      :color="color"
      :width="_width"
      :height="_height"
      :class-name="className"
    />
    <iconfont
      v-if="type === 'font'"
      :name="name"
      :color="color"
      :width="_width"
      :height="_height"
      :class-name="className"
    />
  </div>
  <view v-else class="cube-icon-container">
    <image-icon
      v-if="type === 'svg' || type === 'png'"
      :name="name"
      :type="type"
      :color="color"
      :width="_width"
      :height="_height"
      :class-name="className"
    />
    <iconfont
      v-if="type === 'font'"
      :name="name"
      :color="color"
      :width="_width"
      :height="_height"
      :class-name="className"
    />
  </view>
</template>

<script>
import SymbolIcon from './symbol/index'
import ImageIcon from './image/index'
import Iconfont from './iconfont/index.vue'

// 获取单位中的数值
const v = (v1) =>
  v1.match(/^[\.0-9]+/) ? Number(v1.match(/^[\.0-9]+/)[0]) : v1
// 获取单位
const u = (v2) => (v2.match(/[a-z]+$/) ? v2.match(/[a-z]+$/)[0] : 'px')

/**
 * 转换长度单位
 * 由于 cube-design-web 采用 fontSize: 100px 作为基准值；
 * 因此搭配使用时，图标的尺寸要根据 100px 转成合适的大小；
 * 例如：
 * 1rem => 0.16rem
 * 16px => 0.16rem
 */
const transferLengthUnit = (value) => {
  const unit = u(value)

  try {
    const rootFontSize =
      window && window.getComputedStyle(document.documentElement)['fontSize']
    if (value && v(rootFontSize) === 100) {
      if (unit === 'rem') {
        if (v(value) >= 1) {
          // 如果用户使用大于 1rem ，表示他是基于 1rem = 16px 来定义图标大小
          return `${(16 / 100) * v(value)}rem`
        } else {
          // 如果用户使用小于 1rem ，表示他是基于 1rem = 100px 来定义图标大小
          return value
        }
      } else if (unit === 'px') {
        return `${(v(value) / 16 / 100) * v(value)}rem`
      } else {
        // 如果是 em 单位，不作处理
        return value
      }
    } else {
      // fontSize 不为 100表示没有和 Web 组件库搭配使用，不作处理
      return value
    }
  } catch (error) {
    return value
  }
}

export default {
  name: 'CubeIcon',
  components: {
    SymbolIcon,
    ImageIcon,
    Iconfont
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    color: {
      type: String,
      default: '#23262e'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'symbol'
    }
  },
  data() {
    return {}
  },
  computed: {
    // 判断根字体大小是否为 100px
    fontSize100() {
      try {
        const rootFontSize =
          window &&
          window.getComputedStyle(document.documentElement)['fontSize']
        if (rootFontSize === '100px') {
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },
    _width() {
      return transferLengthUnit(this.size || this.width)
    },
    _height() {
      return transferLengthUnit(this.size || this.height)
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.cube-icon-container {
  display: inline-block;
  line-height: 1; // 避免被父容器的行高所影响
}
</style>
